import defaultColors from "../defaultColors";
import defaultAssets from "../defaultAssets";
const footerLinks = [{
  text: "adFooter.overview",
  href: "https://www.admacademy.ae/about-us/overview/"
}, {
  text: "adFooter.news",
  href: "https://www.admacademy.ae/media/news-events/"
}, {
  text: "adFooter.contact",
  href: "https://www.admacademy.ae/contact-us/"
}];
const ad = {
  name: "Blue theme",
  value: "ad",
  brand: "ADMA",
  website: "#",
  // TODO I should add this to less.json and convert between the two required formats
  colors: { ...defaultColors,
    border: "#e5e5e5",
    primary: "#5472d2",
    primaryLight: "#5472d2",
    primaryLighter: "#5472d2",
    primaryLightest: "#5472d2",
    error: "#f5222d"
  },
  footerLinks: footerLinks,
  verifyURL: "http://verify.example.com",
  phone: "+971 55 160 5623",
  email: "support@educhain.io",
  assets: { ...defaultAssets
  }
};
export { ad };